import React from 'react'
import Subject from './Subject'
import csm from '../assets/CSE402mid21.pdf'
import cse from '../assets/CSE402end21.pdf'
export default function Coa() {
  return (
    <div>
       <Subject title= "Computer Organization & Architecture(CSE402)" sub="COA" syllabus="#"mid="Q. Paper"
    book1="John L Hennessey and David A Patterson, “Computer Architecture A Quantitative Approach”"
    book1Link="https://www.pdfdrive.com/download.pdf?id=35022899&h=fbbf428e356bc619c4b18dc002b3cd63&u=cache&ext=pdf"
     int21="#" mid21={csm} end21={cse}
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}